import example from '../image.png';
function InvalidClinic() {
   return (
      <div className="card my-3 p-1">
         <img className="card-img-top" src={example} alt="Invalid clinic link" />
         <hr/>
         <div className="card-body">
            <h5 className="card-title text-danger">Invalid Clinic Link !</h5>
            <p className="card-text">The link you have entered is not a valid clinic link. Your clinic may have a custom landing page configured. Please go to the top of your webpage and copy the dashboard web address (URL), then paste this into the clinic link field.</p>
         </div>
      </div>
   )
}
export default InvalidClinic;